import "./OneTopTwoBottomLayoutComponent.scss";
import template from "./OneTopTwoBottomLayoutComponent.html";
import {IComponentOptions} from "angular";
import {BreakpointObserver} from "../../../../../services/breakpoints/BreakpointObserver";
import {Observable} from "rxjs";
import {WidgetDisplayMode} from "../../../models/WidgetDisplayMode";
import {Breakpoint} from "../../../../../services/breakpoints/Breakpoint";

export const OneTopTwoBottomLayout = "tfOneTopTwoBottomLayout";

export function oneTopTwoBottom(): IComponentOptions {
    return {
        template,
        controllerAs: "ctrl",
        controller: OneTopTwoBottomLayoutComponent
    };
}

export class OneTopTwoBottomLayoutComponent {

    public readonly bottomWidgetsDisplay$: Observable<WidgetDisplayMode>;

    /** @ngInject */
    public constructor(private readonly breakpointObserver: BreakpointObserver) {
        this.bottomWidgetsDisplay$ = this.buildBottomWidgetsDisplay();
    }

    private buildBottomWidgetsDisplay(): Observable<WidgetDisplayMode> {
        return this.breakpointObserver.observe(Breakpoint.WebLandscape)
                   .map((bp) => bp.active)
                   .map((active) => active ? WidgetDisplayMode.WIDE : WidgetDisplayMode.TALL)
                   .publishReplay(1)
                   .refCount();
    }
}
